'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _chooseProviderActions = require('../chooseProviderActions');

var chooseProviderActions = _interopRequireWildcard(_chooseProviderActions);

var _ChangeProviderCompareComponent = require('./ChangeProviderCompareComponent');

var _ChangeProviderCompareComponent2 = _interopRequireDefault(_ChangeProviderCompareComponent);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/prop-types */
var ChangeProviderCompare = function (_Component) {
  (0, _inherits3.default)(ChangeProviderCompare, _Component);

  function ChangeProviderCompare() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ChangeProviderCompare);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ChangeProviderCompare.__proto__ || (0, _getPrototypeOf2.default)(ChangeProviderCompare)).call.apply(_ref, [this].concat(args))), _this), _this.back = function () {
      _this.props.goBackwards();
    }, _this.close = function () {
      _this.props.close();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ChangeProviderCompare, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          providers = _props.providers,
          learnMore = _props.learnMore,
          openSupportDialog = _props.openSupportDialog;


      return _react2.default.createElement(_ChangeProviderCompareComponent2.default, {
        providers: providers,
        learnMore: learnMore,
        openSupportDialog: openSupportDialog,
        onClose: function onClose() {
          return _this2.close();
        },
        onBack: function onBack() {
          return _this2.back();
        },
        t: this.props.t
      });
    }
  }]);
  return ChangeProviderCompare;
}(_react.Component);
/* eslint-enable react/prop-types */

function mapStateToProps(state) {
  return state;
}

var ConnectedChangeProviderCompare = (0, _reactRedux.connect)(mapStateToProps, chooseProviderActions)(ChangeProviderCompare);

exports.default = ConnectedChangeProviderCompare;